'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AUD = exports.AUD = 'AUD';
var BGN = exports.BGN = 'BGN';
var BRL = exports.BRL = 'BRL';
var CAD = exports.CAD = 'CAD';
var CHF = exports.CHF = 'CHF';
var CNY = exports.CNY = 'CNY';
var CZK = exports.CZK = 'CZK';
var DKK = exports.DKK = 'DKK';
var EUR = exports.EUR = 'EUR';
var GBP = exports.GBP = 'GBP';
var HKD = exports.HKD = 'HKD';
var HRK = exports.HRK = 'HRK';
var HUF = exports.HUF = 'HUF';
var IDR = exports.IDR = 'IDR';
var ILS = exports.ILS = 'ILS';
var INR = exports.INR = 'INR';
var JPY = exports.JPY = 'JPY';
var KRW = exports.KRW = 'KRW';
var MXN = exports.MXN = 'MXN';
var MYR = exports.MYR = 'MYR';
var NOK = exports.NOK = 'NOK';
var NZD = exports.NZD = 'NZD';
var PHP = exports.PHP = 'PHP';
var PLN = exports.PLN = 'PLN';
var RON = exports.RON = 'RON';
var RUB = exports.RUB = 'RUB';
var SEK = exports.SEK = 'SEK';
var SGD = exports.SGD = 'SGD';
var THB = exports.THB = 'THB';
var TRY = exports.TRY = 'TRY';
var USD = exports.USD = 'USD';
var ZAR = exports.ZAR = 'ZAR';

var SUPPORTED_CURRENCIES = exports.SUPPORTED_CURRENCIES = [AUD, BGN, BRL, CAD, CHF, CNY, CZK, DKK, EUR, GBP, HKD, HRK, HUF, IDR, ILS, INR, JPY, KRW, MXN, MYR, NOK, NZD, PHP, PLN, RON, RUB, SEK, SGD, THB, TRY, USD, ZAR];

exports.default = {
  aud: {
    symbol: 'A$'
  },
  bgn: {
    symbol: 'лв'
  },
  brl: {
    symbol: 'R$',
    thousand: '.',
    decimal: ','
  },
  cad: {
    symbol: 'C$'
  },
  chf: {
    symbol: 'CHF'
  },
  cny: {
    symbol: 'CN¥'
  },
  czk: {
    symbol: 'Kč',
    thousand: ' ',
    decimal: ','
  },
  dkk: {
    symbol: 'DKK',
    thousand: '.',
    decimal: ','
  },
  eur: {
    symbol: '€',
    thousand: '.',
    decimal: ','
  },
  gbp: {
    symbol: '£'
  },
  hkd: {
    symbol: 'HK$'
  },
  hrk: {
    symbol: 'A$',
    thousand: '.',
    decimal: ','
  },
  huf: {
    symbol: 'Ft',
    thousand: ' ',
    decimal: ','
  },
  idr: {
    symbol: 'Rp',
    thousand: '.',
    decimal: ','
  },
  ils: {
    symbol: '₪'
  },
  inr: {
    symbol: '₹'
  },
  jpy: {
    symbol: '¥'
  },
  krw: {
    symbol: '₩'
  },
  mxn: {
    symbol: 'MEX$'
  },
  myr: {
    symbol: 'RM'
  },
  nok: {
    symbol: 'NOK',
    thousand: '.',
    decimal: ','
  },
  nzd: {
    symbol: 'NZ$'
  },
  php: {
    symbol: '₱'
  },
  pln: {
    symbol: 'zł',
    thousand: ' ',
    decimal: ','
  },
  ron: {
    symbol: 'Lei',
    thousand: '.',
    decimal: ','
  },
  rub: {
    symbol: '₽',
    thousand: '.',
    decimal: ','
  },
  sek: {
    symbol: 'SEK',
    thousand: ' ',
    decimal: ','
  },
  sgd: {
    symbol: 'S$'
  },
  thb: {
    symbol: '฿'
  },
  try: {
    symbol: '₺',
    thousand: '.',
    decimal: ','
  },
  zar: {
    symbol: 'R'
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@paybygroup/baelish/dist/special-formats.js
// module id = 557
// module chunks = 1 2